import ElaborazioniBatchPage from "./pages/ElaborazioniBatchPage.vue";
import ElaborazioniBatchElaborazioniListPage from "./pages/ElaborazioniBatchElaborazioniListPage.vue";
import ElaborazioniBatchFilesPage from "./pages/ElaborazioniBatchFilesPage.vue";

export default {
    ElaborazioniBatchPage,
    ElaborazioniBatchElaborazioniListPage,
    ElaborazioniBatchFilesPage,
};
